<template>
  <span class="toolbar-separator"></span>
</template>

<style scoped lang="scss">
.toolbar-separator {
  margin: 0 0.5rem;
  @include media-breakpoint-down(md) {
    margin: 0;
  }
}
</style>
